// Regex from: https://stackoverflow.com/a/9204568/12163270
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isValidEmail(email) {
    return EMAIL_REGEX.test(email);
}
